export default __webpack_public_path__ + "static/works_1-4f2917e30fd76766976f07d29d63b036.png";